import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Trophy, ArrowRight } from "lucide-react";

const CrewThanks = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [crewToken, setCrewToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!sid) { setStatus("missing"); return; }
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/night/crew/thanks?session_id=${sid}`);
        if (data.paid && data.crew_token) {
          setCrewToken(data.crew_token);
          setStatus("ready");
          // Short delay then redirect
          setTimeout(() => navigate(`/night/crew/${data.crew_token}`), 1200);
          return;
        }
      } catch (err) { /* retry */ }
      tries += 1;
      if (tries < 20) setTimeout(tick, 1500);
      else setStatus("timeout");
    };
    tick();
  }, [sid, navigate]);

  return (
    <div className="grain min-h-screen flex items-center justify-center">
      <div className="card-noir p-8 max-w-md text-center" data-testid="crew-thanks">
        {status === "polling" && (
          <>
            <Loader2 size={28} className="mx-auto animate-spin text-[#d4af37] mb-3" />
            <div className="font-display text-xl text-[#f4f0ec] mb-2">Confirming your payment…</div>
            <div className="text-xs text-[#a39797]">Hang tight — unlocking your crew room.</div>
          </>
        )}
        {status === "ready" && (
          <>
            <Trophy size={32} className="mx-auto text-[#d4af37] mb-3" />
            <div className="font-display text-2xl text-[#f4f0ec] mb-2">Crew Night unlocked.</div>
            <div className="text-xs text-[#a39797] mb-3">Taking you to your private room…</div>
            <Link to={`/night/crew/${crewToken}`} className="btn-primary text-sm" data-testid="crew-thanks-room">
              Open the room <ArrowRight size={14} />
            </Link>
          </>
        )}
        {status === "timeout" && (
          <>
            <div className="font-display text-xl text-[#f4f0ec] mb-2">Taking longer than expected</div>
            <div className="text-xs text-[#a39797] mb-3">
              Payment is confirmed but we're still provisioning your room. Check your email in a few minutes
              or email support@wasntme.party.
            </div>
            <Link to="/night" className="btn-ghost text-sm">Back to NYE Night</Link>
          </>
        )}
        {status === "missing" && (
          <>
            <div className="font-display text-xl text-[#f4f0ec] mb-2">Missing session</div>
            <Link to="/night" className="btn-ghost text-sm">Back to NYE Night</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default CrewThanks;
